export const truncate = (str: string, n: number): string => {
  return str.length > n ? str.slice(0, n - 3) + "..." : str;
};
